// CYBORG-1416: PostHog trace of the agent pane header's Goal and shells pills and the retry line.
// Counted outcomes validated by the UI KPI catalog (@cyborg7/observability/ui-kpi): ids and counts only,
// never the goal text or a command. "Shown" fires once per appearance (the caller edge-triggers it);
// the throttle only guards a flapping signal against the relay's client-report budget.
import { reportUiKpi, shouldReport } from "$lib/report-failure.js";

const THROTTLE_MS = 5_000;

function once(key: string, source: string, fields: Parameters<typeof reportUiKpi>[1]): void {
  if (shouldReport(`${source}:${key}`, THROTTLE_MS)) reportUiKpi(source, fields);
}

export function reportGoalPillShown(agentId: string): void {
  once(agentId, "activity.goal_pill_shown", { agentId });
}

export function reportGoalPillClicked(agentId: string): void {
  once(agentId, "activity.goal_pill_clicked", { agentId });
}

export function reportShellsPillShown(agentId: string, count: number): void {
  once(agentId, "activity.shells_pill_shown", { agentId, count });
}

export function reportShellsPillClicked(agentId: string, count: number): void {
  once(agentId, "activity.shells_pill_clicked", { agentId, count });
}

export function reportRetryIndicatorShown(
  agentId: string,
  provider: string,
  attempt: number,
): void {
  once(`${agentId}:${attempt}`, "activity.retry_indicator_shown", { agentId, provider, attempt });
}

// CYBORG-1416: the typing line's usage-limit text, the Info bar's MCP row, a provider notice's toast
// and an expanded plan. `limit` is the provider's window name (five_hour...), a closed vocabulary.
export function reportRateLimitShown(agentId: string, provider: string, limit: string): void {
  once(`${agentId}:${limit}`, "activity.rate_limit_shown", { agentId, provider, limit });
}

export function reportMcpRowOpened(agentId: string, total: number, failed: number): void {
  once(agentId, "activity.mcp_row_opened", { agentId, count: total, failed });
}

export function reportNoticeToastShown(agentId: string, kind: string): void {
  once(`${agentId}:${kind}`, "activity.notice_toast_shown", { agentId, kind });
}

export function reportPlanExpanded(agentId: string, provider: string): void {
  once(agentId, "activity.plan_expanded", { agentId, provider });
}
